










import { defineComponent, onUnmounted, ref } from "@vue/composition-api";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "EnableNsfwModal",
  components: { BaseButton, BaseConfirm },
  setup() {
    const { updateNSFWUserSettings } = useNSFWUserSettings();
    const successCb = ref<() => void>();
    const processing = ref(false);

    const showModal = ref(false);

    const onEnable = async () => {
      try {
        processing.value = true;
        await updateNSFWUserSettings(true);
        showModal.value = false;

        successCb.value && successCb.value();
        successCb.value = undefined;
      } catch (e) {
        successCb.value = undefined;
      } finally {
        processing.value = false;
        showModal.value = false;
      }
    };

    const onEvent = (cb?: () => void) => {
      showModal.value = true;
      if (cb) {
        successCb.value = cb;
      }
    };

    emitter.on<() => void>(EVENTS.ENABLE_NSFW, onEvent);

    onUnmounted(() => {
      emitter.off<() => void>(EVENTS.ENABLE_NSFW, onEvent);
    });

    return { updateNSFWUserSettings, onEnable, showModal, processing };
  },
});
